module.exports = __webpack_public_path__ + "media/images/registered-8e5b19bfae849250265757a260164195.png";